export default __webpack_public_path__ + "static/media/4822edc7e677fd3b07e00c9e46f38def.bed7acc6.png";